import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <p>
        Built and Designed by <b>Henrique Ferreira</b>
      </p>
    </footer>
  );
};

export default Footer;
